/* global axios */
import ApiClient from './ApiClient';

class InboxBusinessHoursAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  show(inboxId) {
    return axios.get(`${this.url}/${inboxId}/business_hours`);
  }

  update(inboxId, data) {
    return axios.patch(`${this.url}/${inboxId}/business_hours`, data);
  }

  reset(inboxId) {
    return axios.post(`${this.url}/${inboxId}/business_hours/reset`);
  }
}

export default new InboxBusinessHoursAPI();
